import { ReduxService } from 'dashboard-services/services';

import { shareDialogPipelineCreatorActions } from 'actions/modules/datascience';

export const shareDialogInitialState = {
  isOpen: false,
  errors: [],
  
  message: "",
  emails: [],
  isShareGroups: false,
  shareGroupAccess: "RWS"
}

export default (state = shareDialogInitialState, action) => {
  switch (action.type) {
    case shareDialogPipelineCreatorActions.ON_CHANGE: {
      if(state[action.name] !== action.value) {
        return ReduxService.updateObject(state, { [action.name]: action.value, errors: (state.errors || []).filter(e => e.field !== `${action.name}`) })
      }
      return state;
    }
    case shareDialogPipelineCreatorActions.SET_ERRORS:
      return ReduxService.updateObject(state, { errors: action.errors })
    case shareDialogPipelineCreatorActions.CLEAN_ALL:
      return shareDialogInitialState;
    default:
      return state; 
  }
}